module.exports = __webpack_public_path__ + "static/media/galleryImg29.0b8deb1b.jpg";